if (!customElements.get('cart-best-seller-recommendations')) {
  class CartBestSellerRecommendations extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.drawerObserver = null;
      this.wasVisible = false;
    }

    connectedCallback() {
      this.content = this.querySelector('[data-content]');
      this.list = this.querySelector('[data-recommendations]');
      this.source = this.querySelector('[data-cart-best-seller-source]');
      this.cartDrawer = this.closest('cart-drawer');
      this.wasVisible = this.isCartDrawerVisible();

      this.renderRecommendations();

      if (!this.cartDrawer) {
        return;
      }

      this.drawerObserver = new MutationObserver(() => {
        const isVisible = this.isCartDrawerVisible();

        if (isVisible && !this.wasVisible) {
          this.renderRecommendations();
        }

        this.wasVisible = isVisible;
      });

      this.drawerObserver.observe(this.cartDrawer, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    disconnectedCallback() {
      this.drawerObserver?.disconnect();
      this.destroySlider();
    }

    isCartDrawerVisible() {
      return this.cartDrawer?.classList.contains('is-visible') || false;
    }

    renderRecommendations() {
      if (!this.list || !this.source) {
        this.hide();
        return;
      }

      const topTemplates = Array.from(this.source.querySelectorAll('template[data-source="top"]'));
      const randomTemplates = Array.from(this.source.querySelectorAll('template[data-source="random"]'));
      const topSelection = this.takeUnique(topTemplates, 3);
      const excludedIds = new Set(topSelection.map(template => template.dataset.productId));
      const randomPool = this.takeUnique(randomTemplates, randomTemplates.length, excludedIds);
      const randomSelection = this.shuffle(randomPool).slice(0, 3);
      const finalSelection = [...topSelection, ...randomSelection].slice(0, 3);

      if (finalSelection.length === 0) {
        this.hide();
        return;
      }

      this.list.innerHTML = '';

      finalSelection.forEach(template => {
        this.list.append(template.content.cloneNode(true));
      });

      if (!document.querySelector('quick-cart-drawer')) {
        this.querySelectorAll('.cart-best-seller-recommendations__item-trigger').forEach(trigger => {
          trigger.remove();
        });
      }

      this.show();
      this.initSlider();
    }

    takeUnique(templates, limit, existingIds = new Set()) {
      const uniqueTemplates = [];
      const seenIds = new Set(existingIds);

      templates.forEach(template => {
        const productId = template.dataset.productId;

        if (!productId || seenIds.has(productId) || uniqueTemplates.length >= limit) {
          return;
        }

        seenIds.add(productId);
        uniqueTemplates.push(template);
      });

      return uniqueTemplates;
    }

    shuffle(items) {
      const shuffledItems = [...items];

      for (let index = shuffledItems.length - 1; index > 0; index -= 1) {
        const randomIndex = Math.floor(Math.random() * (index + 1));
        [shuffledItems[index], shuffledItems[randomIndex]] = [shuffledItems[randomIndex], shuffledItems[index]];
      }

      return shuffledItems;
    }

    initSlider() {
      this.destroySlider();

      if (typeof Swiper === 'undefined') {
        return;
      }

      const sliderElement = this.querySelector('.swiper');

      if (!sliderElement || this.list.children.length === 0) {
        return;
      }

      this.slider = new Swiper(sliderElement, {
        slidesPerView: 'auto',
        spaceBetween: 6
      });
    }

    destroySlider() {
      if (this.slider?.destroy) {
        this.slider.destroy(true, true);
      }

      this.slider = null;
    }

    show() {
      this.classList.remove('is-hidden');
      this.content?.classList.remove('hidden');
    }

    hide() {
      this.destroySlider();
      this.classList.add('is-hidden');
      this.content?.classList.add('hidden');

      if (this.list) {
        this.list.innerHTML = '';
      }
    }
  }

  customElements.define('cart-best-seller-recommendations', CartBestSellerRecommendations);
}
